import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { useContext } from 'react';
import ModalLink from '../../../components/ModalLink';
import ModalContext from '../../../contexts/ModalContext';
import useRouting from '../../../hooks/useRouting';
import { useTranslation } from 'react-i18next';

type NotAuthenticatedModalProps = {
  id: string;
};

export default function NotAuthenticatedModal({ id }: NotAuthenticatedModalProps) {
  const { t } = useTranslation();
  const { r } = useRouting();
  const { closeModal } = useContext(ModalContext);

  return (
    <ModalDialog
      id={id}
      closeViaEscape
      closeOnClickOutside
      closeTitle={t('ACTIONS.CLOSE')}
      onClose={() => closeModal(id)}
      size="small"
    >
      <Dialog.Header title={t('MODULES.MATERIAL.COMPONENTS.MODALS.NOT_AUTHENTICATED.TITLE')} />
      <Dialog.Body>{t('MODULES.MATERIAL.COMPONENTS.MODALS.NOT_AUTHENTICATED.MESSAGE')}</Dialog.Body>
      <Dialog.Footer>
        <ModalLink id={id} to={r('login')} className="bc-button__button bc-button__primary ">
          {t('MODULES.MATERIAL.COMPONENTS.MODALS.NOT_AUTHENTICATED.ACTIONS.LOGIN')}
        </ModalLink>
      </Dialog.Footer>
    </ModalDialog>
  );
}
